import gql from 'graphql-tag';

export const subUnitFragments = gql`
  fragment subUnitFragments on SubUnit {
    id
    organizationNumber
    name
    department {
      id
      name
    }
  }
`;

export const ALL_SUBUNITS = gql`
  query currentUnitSubUnits {
    currentUnit {
      id
      subUnits {
        ...subUnitFragments
      }
    }
  },
  ${subUnitFragments}
`;
